export const image_thumbnail_edits = {
  resize: {
    width: 100,
    height: 100,
    fit: "cover",
  },
}

export const image_small_edits = {
  resize: {
    width: 150,
    height: 150,
    fit: "cover",
  },
}
